module.exports = __webpack_public_path__ + "img/stock5.58f12a24.png";